import { useLocation } from "react-router-dom";
import { ListChecks, Folder, Star, Inbox } from "lucide-react";
import ZoneNav from "./ZoneNav.jsx";

// v8.5.46 · F1 · Piel Estudio (nav) · Pedidos deja de ser un ítem propio del
// Sidebar — pasa a vivir como pestaña de "Trabajo" (mismo patrón que
// Campañas/Favoritos), siguiendo las 5 zonas de la piel Estudio.
const TABS = [
  { to: "/tareas",           label: "Piezas",    icon: ListChecks,
    isActive: (p) => p === "/tareas" },
  { to: "/tareas/pedidos",   label: "Pedidos",   icon: Inbox,
    isActive: (p) => p.startsWith("/tareas/pedidos") },
  { to: "/tareas/campanas",  label: "Campañas",  icon: Folder,
    isActive: (p) => p.startsWith("/tareas/campanas") },
  { to: "/tareas/favoritos", label: "Guardadas", icon: Star,
    isActive: (p) => p === "/tareas/favoritos" },
];

export default function TrabajoLayout() {
  const { pathname } = useLocation();
  const items = TABS.map(t => ({ ...t, active: t.isActive(pathname) }));
  return <ZoneNav items={items}/>;
}
